function cleanText(value) {
  return String(value || "").trim();
}

function normalizedFileName(templateName) {
  const name = cleanText(templateName) || "未命名模板";
  return /\.html?$/i.test(name) ? name : `${name}.html`;
}

function templateIdentityValues(template = {}) {
  const values = [
    template.id,
    template.templateKey,
    template.managedTemplateId,
    template.upstreamManagedTemplateId,
    template.sourceDocumentId,
    template.sourceRecordId,
  ].map(cleanText).filter(Boolean);
  const identities = new Set(values);
  for (const value of values) {
    if (value.startsWith("managed:")) identities.add(value.slice("managed:".length));
    if (value.startsWith("template-call:")) identities.add(value.slice("template-call:".length));
    if (value.startsWith("template-call-default:")) identities.add(value.slice("template-call-default:".length));
  }
  return identities;
}

function sameStableIdentity(left, right) {
  const leftIdentities = templateIdentityValues(left);
  const rightIdentities = templateIdentityValues(right);
  return Array.from(leftIdentities).some((identity) => rightIdentities.has(identity));
}

export function normalizeTemplateCallDefault(template = {}) {
  if (template.templateType && template.templateType !== "system") return null;
  if (!template.isDefaultTemplate) return null;

  const templateName = cleanText(template.templateName || template.displayName || template.fileName);
  const templateKey = cleanText(template.templateKey || template.id || template.managedTemplateId);
  if (!templateName || !templateKey) return null;

  const editableHtml = cleanText(template.templateHtml || template.originalTemplateHtml);
  const templateVersionId = cleanText(template.templateVersionId || template.versionId);
  const upstreamManagedTemplateId = cleanText(template.managedTemplateId);
  const sourceDocumentId = `template-call-default:${templateKey}`;
  const publishedVersion = editableHtml || template.documentJson
    ? {
        id: templateVersionId || `template-call-version:${templateKey}`,
        status: "published",
        versionNo: Number(template.versionNo) || 1,
        editorFormat: "prosemirror",
        editableHtml,
        templateHtml: editableHtml,
        documentJson: template.documentJson || null,
        variables: Array.isArray(template.variables) ? template.variables : [],
        signatureConfig: template.signatureConfig || null,
        requiresElectronicSignature: Boolean(template.requiresElectronicSignature || template.signatureRoles?.length),
      }
    : null;

  return {
    ...template,
    id: `template-call:${templateKey}`,
    templateKey,
    templateName,
    fileName: normalizedFileName(templateName),
    displayName: templateName,
    extension: "html",
    kind: "system",
    templateType: "system",
    templateSource: "模板调用当前默认",
    moduleKey: cleanText(template.moduleKey),
    moduleName: cleanText(template.moduleName),
    submoduleKey: cleanText(template.submoduleKey),
    submoduleName: cleanText(template.submoduleName || template.scenarioName),
    scenarioName: cleanText(template.scenarioName || template.submoduleName),
    sourceDocumentId,
    upstreamManagedTemplateId,
    managedTemplateId: "",
    templateVersionId,
    templateCallDefault: true,
    databaseTemplate: true,
    published: true,
    isCategoryDefault: true,
    publishedVersion,
    templateHtml: undefined,
    originalTemplateHtml: undefined,
  };
}

export function normalizeTemplateCallDefaults(items = []) {
  return items.map(normalizeTemplateCallDefault).filter(Boolean);
}

export function mergeTemplateCallDefaults(existingTemplates = [], defaultTemplates = []) {
  const merged = [...existingTemplates];
  for (const template of defaultTemplates) {
    if (!template || merged.some((existing) => sameStableIdentity(existing, template))) continue;
    merged.push(template);
  }
  return merged;
}
